'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file Insert Google Analytics code into the page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var GoogleAnalytics = function (_React$Component) {
  _inherits(GoogleAnalytics, _React$Component);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Since the component did mount, we can change the DOM -> add the Google
      // Tracking code
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

      this.props.trackers.map(function (tracker) {
        // When creating more than one tracker, each tracker needs to be
        // given its own name, otherwise just one tracker will be created
        window.ga('create', tracker.id, 'auto', tracker.name);
        // When a tracker sends a command, it will have to send the
        // command prefixed with the tracker name, so it will work correctly.
        window.ga(tracker.name + '.send', 'pageview');
      });
    }

    /**
     * There's nothing to render, the DOM changes should happen in
     * componentDidMount() already.
     *
     * @returns {null}
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return GoogleAnalytics;
}(_react2.default.Component);

GoogleAnalytics.propTypes = {
  trackers: _react2.default.PropTypes.array.isRequired
};

GoogleAnalytics.defaultProps = {
  trackers: []
};

exports.default = GoogleAnalytics;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-ga/dist/index.js
// module id = 92
// module chunks = 0